@let groupActionMode = $groupActionMode();
@let isLoading = !!(isLoading$ | async);
@let isInsideSummary = $isInsideSummary();
@let isInsideWorkflow = $isInsideWorkflow();

@if (
  !groupActionMode &&
  !isCreateDialog &&
  !isInsideWorkflow &&
  !dealDetails?.details &&
  !isLoading
) {
  <section class="mt-4.5">
    <x-empty-block
      [title]="'request_form.deal_details.no_deal_details' | translate"
    />
  </section>
}

@if (
  (groupActionMode ||
    isCreateDialog ||
    dealDetails?.details ||
    isInsideWorkflow) &&
  !isInsideSummary
) {
  <div class="flex flex-col items-center w-full">
    <div
      [ngClass]="{
        'md:container': !isCreateDialog,
      }"
    >
      <form [formGroup]="formGroup" (submit)="submit()">
        <div
          class="x-card x-card_size_m mt-4.5 card-shadow x-white"
          [tuiSkeleton]="isLoading"
        >
          <h3 class="font-bold text-[1.1875rem]/7 mb-2">
            {{
              'request_form.deal_details.installer_arrival_time_title'
                | translate
            }}
          </h3>
          <div class="flex flex-row gap-5">
            <div class="w-1/2">
              <label
                for="{{ FormFields.InstallerTime }}"
                class="x-input-label w-1/2"
              >
                {{
                  isCreateDialog
                    ? ('request_form.deal_details.your_arrival_time'
                      | translate)
                    : ('request_form.deal_details.installer_arrival_time'
                      | translate)
                }}
              </label>
              <x-time-picker
                [formControlName]="FormFields.InstallerTime"
                [minutesGap]="5"
              ></x-time-picker>
              @if (
                installerTimeField.touched &&
                installerTimeField.errors?.['required']
              ) {
                <tui-error
                  [error]="
                    'request_form.deal_details.error_required' | translate
                  "
                ></tui-error>
              }
            </div>

            <div class="w-1/2">
              <label
                for="{{ FormFields.SubjTime }}"
                class="x-input-label w-1/2"
                >{{
                  'request_form.deal_details.lessees_arrival_time' | translate
                }}</label
              >
              <x-time-picker
                [formControlName]="FormFields.SubjTime"
                [minutesGap]="5"
              ></x-time-picker>
              @if (
                subjTimeField.touched && subjTimeField.errors?.['required']
              ) {
                <tui-error
                  [error]="
                    'request_form.deal_details.error_required' | translate
                  "
                ></tui-error>
              }
            </div>
          </div>
        </div>

        <div
          class="x-card x-card_size_m mt-2 card-shadow x-white"
          [tuiSkeleton]="isLoading"
        >
          <h3 class="font-bold text-[1.1875rem]/7 mb-2">
            {{ 'request_form.deal_details.deal_time_title' | translate }}
          </h3>
          <div class="flex flex-row gap-5">
            <div class="w-1/2">
              <label
                for="{{ FormFields.ReleaseStartTime }}"
                class="x-input-label w-1/2"
              >
                {{
                  'request_form.deal_details.deal_start_time' | translate
                }}</label
              >
              <x-time-picker
                [formControlName]="FormFields.ReleaseStartTime"
                [minutesGap]="5"
              ></x-time-picker>
              @if (
                releaseStartTimeField.touched &&
                releaseStartTimeField.errors?.['required']
              ) {
                <tui-error
                  [error]="
                    'request_form.deal_details.error_required' | translate
                  "
                ></tui-error>
              }
            </div>
            <div class="w-1/2">
              <label
                for="{{ FormFields.CompletedTime }}"
                class="x-input-label w-1/2"
                >{{
                  'request_form.deal_details.deal_end_time' | translate
                }}</label
              >
              <x-time-picker
                [formControlName]="FormFields.CompletedTime"
                [minutesGap]="5"
              ></x-time-picker>
              @if (
                completedTimeField.touched &&
                completedTimeField.errors?.['required']
              ) {
                <tui-error
                  [error]="
                    'request_form.deal_details.error_required' | translate
                  "
                ></tui-error>
              }
            </div>
          </div>
        </div>

        <div
          tuiGroup
          orientation="vertical"
          class="x-card x-card_size_m group mt-2 card-shadow p-0 w-full x-white"
          [collapsed]="true"
          [tuiSkeleton]="isLoading"
        >
          <h3 class="font-bold text-[1.1875rem]/7 w-full p-4">
            {{ 'request_form.deal_details.installing_place_title' | translate }}
          </h3>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.installing_place_outdoor' | translate
            }}
            <input
              tuiRadio
              type="radio"
              [formControlName]="FormFields.InstallingEnv"
              [value]="RequestDealDetailsInstallingEnv.Outdoor"
            />
          </label>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.installing_place_indoor' | translate
            }}
            <input
              tuiRadio
              type="radio"
              [formControlName]="FormFields.InstallingEnv"
              [value]="RequestDealDetailsInstallingEnv.Indoor"
            />
          </label>
        </div>

        <div
          tuiGroup
          orientation="vertical"
          class="x-card x-card_size_m group mt-2 card-shadow p-0 w-full x-white"
          [collapsed]="true"
          [tuiSkeleton]="isLoading"
        >
          <h3 class="font-bold text-[1.1875rem]/7 w-full p-4">
            {{ 'request_form.deal_details.devices_demount_title' | translate }}
          </h3>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{ 'request_form.deal_details.demount_exist' | translate }}
            <input
              tuiCheckbox
              type="checkbox"
              [(ngModel)]="hasDemountedDevices"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="!$canExecuteWorkflow() && $isInsideWorkflow()"
            />
          </label>
          @if (hasDemountedDevices()) {
            <label
              for="{{ FormFields.DemountedDevicesCount }}"
              class="x-input-label p-2"
              >{{
                'request_form.deal_details.demount_count' | translate
              }}</label
            >
            <tui-textfield>
              <input
                tuiInputNumber
                [formControlName]="FormFields.DemountedDevicesCount"
                [max]="5"
                [min]="1"
                placeholder="{{
                  'request_form.deal_details.demount_placeholder' | translate
                }}"
              />
            </tui-textfield>
            @if (
              demountedDevicesCountField.touched &&
              demountedDevicesCountField.errors?.['required']
            ) {
              <tui-error
                class="p-2"
                [error]="
                  'request_form.deal_details.demount_count_error' | translate
                "
              ></tui-error>
            }
          }
        </div>

        <div
          tuiGroup
          orientation="vertical"
          class="x-card x-card_size_m group mt-2 card-shadow p-0 w-full x-white"
          [collapsed]="true"
          [tuiSkeleton]="isLoading"
        >
          <h3 class="font-bold text-[1.1875rem]/7 w-full p-4">
            {{ 'request_form.deal_details.additionally_title' | translate }}
          </h3>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.additionally_third_parties' | translate
            }}
            <input
              tuiCheckbox
              type="checkbox"
              [formControlName]="FormFields.ThirdParties"
            />
          </label>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.additionally_documents_given'
                | translate
            }}
            <input
              tuiCheckbox
              type="checkbox"
              [formControlName]="FormFields.DocumentsGiven"
            />
          </label>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.additionally_keys_given' | translate
            }}
            <input
              tuiCheckbox
              type="checkbox"
              [formControlName]="FormFields.KeysGiven"
            />
          </label>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.additionally_nothing_given' | translate
            }}
            <input
              tuiCheckbox
              type="checkbox"
              [formControlName]="FormFields.NothingGiven"
            />
          </label>
        </div>

        <div
          tuiGroup
          orientation="vertical"
          class="x-card x-card_size_m group mt-2 card-shadow p-0 w-full x-white"
          [collapsed]="true"
          [tuiSkeleton]="isLoading"
        >
          <h3 class="font-bold text-[1.1875rem]/7 w-full p-4">
            {{ 'request_form.deal_details.primary_documentation' | translate }}
            @if ($isPrimaryDocumentationRequired()) {
              <span class="x-text-red">*</span>
            }
          </h3>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.primary_documentation_edo' | translate
            }}
            <input
              tuiRadio
              type="radio"
              [formControlName]="FormFields.PrimaryDocumentation"
              [value]="PrimaryDocumentation.EDO"
            />
          </label>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.primary_documentation_paper'
                | translate
            }}
            <input
              tuiRadio
              type="radio"
              [formControlName]="FormFields.PrimaryDocumentation"
              [value]="PrimaryDocumentation.PAPER"
            />
          </label>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.primary_documentation_absent'
                | translate
            }}
            <input
              tuiRadio
              type="radio"
              [formControlName]="FormFields.PrimaryDocumentation"
              [value]="PrimaryDocumentation.ABSENT"
            />
          </label>
          <label
            tuiBlock="m"
            class="justify-between w-full invert-background-color"
          >
            {{
              'request_form.deal_details.primary_documentation_not_filled'
                | translate
            }}
            <input
              tuiRadio
              type="radio"
              [formControlName]="FormFields.PrimaryDocumentation"
              [value]="null"
            />
          </label>
          @if (
            (groupActionMode ||
              primaryDocumentationField.touched ||
              primaryDocumentationField.dirty) &&
            primaryDocumentationField.errors?.['required']
          ) {
            <tui-error
              class="p-2"
              [error]="'request_form.deal_details.error_required' | translate"
            ></tui-error>
          }
        </div>

        @if (!isInsideWorkflow) {
          @if (groupActionMode) {
            <x-request-form-ratings
              [groupActionMode]="true"
              [viewObserver]="$groupActionsViewObserver()"
              [isInsideDealDetails]="true"
            />

            <x-actual-delivery-address-group-actions-view
              class="mt-2"
              [viewObserver]="$groupActionsViewObserver()!"
            />
          } @else {
            <x-request-form-ratings [isInsideDealDetails]="true" />
            <x-request-form-actual-address [isInsideDealDetails]="true" />
          }
        }

        <div
          class="x-card x-card_size_m mt-2 card-shadow x-white"
          [tuiSkeleton]="isLoading"
        >
          <h3 class="font-bold text-[1.1875rem]/7 mb-2">
            {{ 'request_form.deal_details.notes_title' | translate }}
          </h3>

          <tui-textfield class="h-40">
            <textarea
              tuiTextarea
              [limit]="10_000"
              [formControlName]="FormFields.Problems"
              [min]="6"
              [max]="12"
            ></textarea>
          </tui-textfield>
          @if (problemsField.touched && problemsField.errors?.['maxlength']) {
            <tui-error
              [error]="
                'request_form.deal_details.notes_max_chars_error'
                  | translate: { maxLength: '10 000' }
              "
            ></tui-error>
          }
        </div>

        <div
          class="flex flex-col w-full md:gap-2 md:flex-row md:justify-end"
          [tuiSkeleton]="isLoading"
          [class.rounded-[0.75rem]]="isLoading"
        >
          @if (
            (groupActionMode ||
              isCreateDialog ||
              (permissionService.canEditDealDetails$ | async)) &&
            !isInsideWorkflow
          ) {
            <button
              tuiButton
              type="submit"
              [size]="(deviceDetectorService.isMobile$ | async) ? 'l' : 'm'"
              class="mt-2 w-full md:w-40"
              appearance="primary"
              [disabled]="formGroup.invalid"
            >
              {{ 'request_form.deal_details.button_save' | translate }}
            </button>
          }
          @if (isCreateDialog) {
            <button
              tuiButton
              type="button"
              [size]="(deviceDetectorService.isMobile$ | async) ? 'l' : 'm'"
              class="mt-2 w-full md:w-40"
              appearance="blue"
              (click)="dismiss()"
            >
              {{ 'request_form.deal_details.button_close' | translate }}
            </button>
          }
        </div>
      </form>
    </div>
  </div>
}

@if (dealDetails?.details && isInsideSummary) {
  <form
    [formGroup]="formGroup"
    (submit)="submit()"
    [tuiSkeleton]="isLoading"
    [ngClass]="{ 'min-h-[230px]': isLoading }"
  >
    <section class="grid gap-5 items-baseline grid-cols-3">
      <div class="col-start-1 col-span-1">
        @for (
          field of [
            {
              label:
                'request_form.deal_details.installer_arrival_time' | translate,
              field: installerTimeField,
            },
            {
              label:
                'request_form.deal_details.lessees_arrival_time' | translate,
              field: subjTimeField,
            },
            {
              label: 'request_form.deal_details.deal_start_time' | translate,
              field: releaseStartTimeField,
            },
            {
              label: 'request_form.deal_details.deal_end_time' | translate,
              field: completedTimeField,
            },
          ];
          track field
        ) {
          <ng-container
            [ngTemplateOutlet]="summaryFormField"
            [ngTemplateOutletContext]="field"
          ></ng-container>
        }
        <div class="flex items-center justify-between w-4/5">
          <p class="x-font-body-4">
            {{ 'request_form.deal_details.deal_duration' | translate }}
          </p>
          <p class="x-font-body-4-bold">
            {{
              dealDetails!.details?.durationInHours ||
                'request_form.deal_details.not_defined_value' | translate
            }}
          </p>
        </div>
      </div>
      <div class="col-start-2 col-span-1">
        <div class="flex items-center justify-between mb-2 w-4/5">
          <p class="x-font-body-4">
            {{ 'request_form.deal_details.installing_place_title' | translate }}
          </p>
          <p class="x-font-body-4-bold">
            {{
              !installingEnvField.getRawValue()
                ? ('request_form.deal_details.not_defined_value' | translate)
                : installingEnvField.getRawValue() ===
                    RequestDealDetailsInstallingEnv.Outdoor
                  ? ('request_form.deal_details.installing_place_outdoor'
                    | translate)
                  : ('request_form.deal_details.installing_place_indoor'
                    | translate)
            }}
          </p>
        </div>
        <ng-container
          [ngTemplateOutlet]="summaryFormField"
          [ngTemplateOutletContext]="{
            label: 'request_form.deal_details.demount_count' | translate,
            field: demountedDevicesCountField,
            fullWidth: false,
            red: demountedDevicesCountField.value,
          }"
        ></ng-container>
        @for (
          item of [
            {
              label: 'request_form.deal_details.deal_was_done' | translate,
              field: thirdPartiesField,
              yes:
                'request_form.deal_details.additionally_third_parties'
                | translate,
              no: 'request_form.deal_details.without_third_parties' | translate,
            },
            {
              label:
                'request_form.deal_details.additionally_documents_given'
                | translate,
              field: documentsGivenField,
              yes: 'request_form.deal_details.boolean_field_yes' | translate,
              no: 'request_form.deal_details.boolean_field_no' | translate,
            },
          ];
          track item
        ) {
          <div class="flex items-center justify-between mb-2 w-4/5">
            <p class="x-font-body-4">{{ item.label | translate }}</p>
            <p class="x-font-body-4-bold">
              {{
                item.field.getRawValue()
                  ? (item.yes | translate)
                  : (item.no | translate)
              }}
            </p>
          </div>
        }
        <div class="flex items-center justify-between mb-2 w-4/5">
          <p class="x-font-body-4">
            {{
              'request_form.deal_details.additionally_keys_given' | translate
            }}
          </p>
          @let keysGiven = keysGivenField.getRawValue();
          <p
            class="x-font-body-4-bold"
            [ngClass]="{ 'x-text-red': !keysGiven }"
          >
            {{
              keysGiven
                ? ('request_form.deal_details.boolean_field_yes' | translate)
                : ('request_form.deal_details.boolean_field_no' | translate)
            }}
          </p>
        </div>
        <div class="flex items-center justify-between mb-2 w-4/5">
          <p class="x-font-body-4">
            {{ 'request_form.deal_details.primary_documentation' | translate }}
          </p>
          <p class="x-font-body-4-bold">
            {{ primaryDocumentationTranslationKey | translate }}
          </p>
        </div>
      </div>
      <div class="col-start-3 col-span-1 h-full">
        <p class="x-font-body-1-bold mb-2">
          {{ 'request_form.deal_details.notes_title' | translate }}
        </p>
        <tui-textfield class="h-40">
          <textarea
            tuiTextarea
            [limit]="10_000"
            [readOnly]="true"
            [formControlName]="FormFields.Problems"
            [min]="6"
            [max]="12"
          ></textarea>
        </tui-textfield>
      </div>
    </section>
    <section class="mt-5">
      <x-request-form-ratings [isInsideSummary]="true" />
    </section>
  </form>
}

<ng-template
  #summaryFormField
  let-label="label"
  let-field="field"
  let-last="last"
  let-fullWidth="fullWidth"
  let-red="red"
>
  <div
    class="flex items-center justify-between"
    [ngClass]="{ 'mb-2': !last, 'w-4/5': !fullWidth, 'x-text-red': red }"
  >
    <p class="x-font-body-4">
      {{ label }}
    </p>
    <p class="x-font-body-4-bold">
      {{
        field.getRawValue() || 'request_form.deal_details.not_defined_value'
          | translate
      }}
    </p>
  </div>
</ng-template>
